import React from 'react'
import { ApolloProvider } from 'react-apollo'
import ApolloClient, { InMemoryCache } from "apollo-boost"
import { persistCache } from 'apollo-cache-persist'
import { REFRESH_TOKEN } from 'operations/User'
import jwtDecode from 'jwt-decode'

class Apollo extends React.Component {

    state = {
        client: null,
        loaded: false,
    }

    async componentDidMount() {

        const cache = new InMemoryCache()

        const defaults = {
            isAuthenticated: false
        }
        
        const typeDefs = `
        
            type Query {
                isAuthenticated: Boolean!
            }
        
        `
        
        const resolvers = {
            Mutation: {
                toggleAuth: (_, { isAuthenticated }, { cache, getCacheKey }) => {
                    const data = {
                        isAuthenticated
                    }
                    cache.writeData({ data })
                    return null
                },
            }
        }

        const client = new ApolloClient({
            uri: process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : 'https://api.tueri.io',
            request: (operation) => {
                const headers = {}
                const token = localStorage.getItem('accessToken') || null
                if (token) {
                    headers.authorization = 'Bearer ' + token
                }
                operation.setContext({ headers })
            },
            onError:({ graphQLErrors, networkError }) => {
                if (networkError) {
                    console.log(networkError, networkError.statusCode)
                    if (networkError.statusCode === 401) {
        
                        localStorage.removeItem('accessToken');
                        const refreshToken = localStorage.getItem('refreshToken')
                        if (refreshToken) {
                            client.mutate({
                                mutation: REFRESH_TOKEN,
                                variables: {
                                    input: {
                                        token: refreshToken
                                    }
                                }
                            })
                            .then(({data}) => {
                                localStorage.setItem('accessToken', data.refreshToken.accessToken)
                                const decoded = jwtDecode(data.refreshToken.accessToken)
                                localStorage.setItem('tokenExpiry', decoded.exp)
                            })
                            .catch(err => {
                                localStorage.removeItem('accessToken')
                                localStorage.removeItem('refreshToken')
                                localStorage.removeItem('tokenExpiry')
                                client.resetStore()
                            })
                        }
                        else {
                            client.resetStore()
                            localStorage.removeItem('accessToken')
                            localStorage.removeItem('refreshToken')
                            localStorage.removeItem('tokenExpiry')
                        }
        
                    }
                }
            },
            clientState: {
                defaults,
                resolvers,
                typeDefs
            },
            cache
        })

        try {
            // See above for additional options, including other storage providers.
            await persistCache({
              cache,
              storage: window.localStorage,
            })

        } catch (error) {
            console.error('Error restoring Apollo cache', error)
        }

        this.setState({
            client,
            loaded: true,
        })

    }

    render() {
        const { client, loaded } = this.state
        const { children } = this.props
    
        if (!loaded) {
            return null
        }
    
        return (
            <ApolloProvider client={client}>
            { children }
            </ApolloProvider>
        );
    }

}

export {
    Apollo as ApolloProvider
}


// WEBPACK FOOTER //
// ./src/Apollo.js